import { render } from "./SalesTable.vue?vue&type=template&id=9ca66886&scoped=true"
import script from "./SalesTable.vue?vue&type=script&lang=js"
export * from "./SalesTable.vue?vue&type=script&lang=js"

import "./SalesTable.vue?vue&type=style&index=0&id=9ca66886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca66886"]])

export default __exports__